import { render, staticRenderFns } from "./BureauTreeChart.vue?vue&type=template&id=5b3bdd80&scoped=true&"
import script from "./BureauTreeChart.vue?vue&type=script&lang=js&"
export * from "./BureauTreeChart.vue?vue&type=script&lang=js&"
import style0 from "./BureauTreeChart.vue?vue&type=style&index=0&id=5b3bdd80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3bdd80",
  null
  
)

export default component.exports